(ns app.front.view.group.admin.fees.bill.template
  (:require [app.domain.fee.model :as fee-model]
            [app.front.file.download :as file-download]
            [app.front.ui :as ui]
            [app.front.ui.text-editor :as text-editor]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.admin.templates.document-editor :as document-editor]
            [app.front.view.group.admin.templates.language-selector :as lang-sel]
            [core.front.event :refer [<sub]]
            [core.front.feature-flags :as ff]
            [core.util.util :as util]))

(defn view [tr group-id template inherited? replace-template]
  (let [images      (<sub [::gas/verdict-images group-id])
        document-id (:db/id template)]
    [document-editor/editor
     (-> (util/mmap {:title              [:h3 (tr [:entity.type/bill-pdf-template])]
                     :read-only?         inherited?
                     :replace-template   replace-template
                     :preview-url        (file-download/download-href
                                           :group/generate-bill-template-preview-pdf
                                           {:group-id    group-id
                                            :template-id document-id})
                     :placeholders       (remove #{"gl-code-column-class"}
                                                 (fee-model/bill-picker-variables (<sub [::ff/enabled-flags])))
                     :html-fragment-type :bill-fragment/html-template
                     :css-fragment-type  :bill-fragment/print-css}
                    tr images group-id document-id)
         (text-editor/with-external-edit-state ::main))
     [:div
      (when (<sub [::lang-sel/show-selector?])
        [ui/help (tr [:group-locales/multiple-locales-template-help])])
      [document-editor/editor
       (-> (util/mmap
             {:title              [:h4 (tr [:bill/bill-group-snippet])]
              :read-only?         inherited?
              :placeholders       fee-model/bill-group-snippet-variables
              :small?             true
              :html-fragment-type :bill-fragment/group-snippet}
             tr images group-id document-id)
           (text-editor/with-external-edit-state ::group))
       [document-editor/editor
        (-> (util/mmap
              {:title              [:h4 (tr [:bill/bill-item-snippet])]
               :read-only?         inherited?
               :placeholders       fee-model/bill-item-snippet-variables
               :small?             true
               :html-fragment-type :bill-fragment/item-snippet}
              tr images group-id document-id)
            (text-editor/with-external-edit-state ::item))]]]]))
